module.exports = {"GENERIC":{"SELECTED_ALL":"selected-all","UNSELECTED_ALL":"unselected-all","SELECTED_ITEM":"selected","UNSELECTED_ITEM":"unselected","EXPORT":"export"},"RFP":{"CREATED":"rfp-created","RECEIVED":"rfp-received","SENT":"rfp-sent"},"PROGRAM":{"CREATED":"program-created","RECEIVED":"program-received","SENT":"program-sent"}}


//////////////////
// WEBPACK FOOTER
// ./src/core/events/events.json
// module id = 1RXC
// module chunks = 13 14